/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AddTeamDto = {
    sportsClubId: number;
    teamType: AddTeamDto.teamType;
    teamSubtype?: AddTeamDto.teamSubtype;
    tier?: AddTeamDto.tier;
    gender?: AddTeamDto.gender;
    ageCategory?: AddTeamDto.ageCategory;
    yearOfBirth?: AddTeamDto.yearOfBirth;
};
export namespace AddTeamDto {
    export enum teamType {
        SENIOR = 'SENIOR',
        YOUTH = 'YOUTH',
    }
    export enum teamSubtype {
        FIRST_TEAM = 'FIRST_TEAM',
        SECOND_TEAM = 'SECOND_TEAM',
        THIRD_TEAM = 'THIRD_TEAM',
    }
    export enum tier {
        EKSTRAKLASA = 'EKSTRAKLASA',
        FIRST_LEAGUE = 'FIRST_LEAGUE',
        SECOND_LEAGUE = 'SECOND_LEAGUE',
        THIRD_LEAGUE = 'THIRD_LEAGUE',
        FOURTH_LEAGUE = 'FOURTH_LEAGUE',
        FIFTH_LEAGUE = 'FIFTH_LEAGUE',
        REGIONAL_CLASS = 'REGIONAL_CLASS',
        CLASS_A = 'CLASS_A',
        CLASS_B = 'CLASS_B',
        CLASS_C = 'CLASS_C',
        CLJ = 'CLJ',
        VOIVODESHIP_I = 'VOIVODESHIP_I',
        VOIVODESHIP_2 = 'VOIVODESHIP_2',
        VOIVODESHIP_3 = 'VOIVODESHIP_3',
        REGIONAL = 'REGIONAL',
    }
    export enum gender {
        FEMALE = 'FEMALE',
        MALE = 'MALE',
    }
    export enum ageCategory {
        JUNIOR_STARSZY = 'JUNIOR_STARSZY',
        JUNIOR_MLODSZY = 'JUNIOR_MLODSZY',
        TRAMPKARZ = 'TRAMPKARZ',
        MLODZIK = 'MLODZIK',
        ORLIK = 'ORLIK',
        ZAK = 'ZAK',
        SKRZAT = 'SKRZAT',
    }
    export enum yearOfBirth {
        YEAR_2007 = 'YEAR_2007',
        YEAR_2008 = 'YEAR_2008',
        YEAR_2009 = 'YEAR_2009',
        YEAR_2010 = 'YEAR_2010',
        YEAR_2011 = 'YEAR_2011',
        YEAR_2012 = 'YEAR_2012',
        YEAR_2013 = 'YEAR_2013',
        YEAR_2014 = 'YEAR_2014',
        YEAR_2015 = 'YEAR_2015',
        YEAR_2016 = 'YEAR_2016',
        YEAR_2017 = 'YEAR_2017',
        YEAR_2018 = 'YEAR_2018',
        YEAR_2019 = 'YEAR_2019',
        YEAR_2020 = 'YEAR_2020',
    }
}

